
export const lg_header_menu = {
  lg_header_menu_th: {
    home: "หน้าแรก",
    feature: "ฟีเจอร์",
    pricing: "ราคา",
    contact: "ติดต่อ",
    joinmeetbyid: "เข้าร่วมการประชุม",
    signin: "เข้าสู่ระบบ",
    registerformeeting: "เริ่มฟรี",
    about: "เกี่ยวกับเรา",
    lh_my_meetings: "การประชุมของฉัน",
    lh_account: "บัญชีของฉัน",
  },
  lg_header_menu_en: {
    home: "Home",
    feature: "Feature",
    pricing: "Pricing",
    contact: "Contact",
    joinmeetbyid: "Join Meeting",
    signin: "Sign In",
    registerformeeting: "Start Free",
    about: "About",
    lh_my_meetings: "My Meetings",
    lh_account: "My Account",
  },
};

// import {feature} from "@/services/constants";
//  let lg_header_menu = {
//     lg_header_menu_th: {
//         home: "หน้าแรก",
//         feature:"ฟีเจอร์",
//         contact:"ติดต่อเรา",
//         joinmeetbyid:"เข้าประขุมด้วย ID",
//     },
//     lg_header_menu_en: {
//       home: "Home",
//       feature:"Feature",
//       contact:"contact",
//       joinmeetbyid:"Joinmeet By ID",
//     },
//   };
//   console.log("ภาษา คือ" + localStorage.getItem(feature.LANGUAGE))
//   if(localStorage.getItem(feature.LANGUAGE) === 'th'){
//     lg_header_menu = lg_header_menu.lg_header_menu_th
//   }else{
//     lg_header_menu = lg_header_menu.lg_header_menu_en
//   }
//   console.log(lg_header_menu)

// export default lg_header_menu;